import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'spinner-border-sm';
      case 'large':
        return 'spinner-border-lg';
      default:
        return '';
    }
  };

  return (
    <div className="loading-container">
      <div className={`spinner-border text-primary ${getSizeClass()}`} role="status">
        <span className="visually-hidden">{text}</span>
      </div>
      <div className="loading-text">
        <p className="text-muted">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
